import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/Feedback/rect.png'


const _hoisted_1 = { class: "feedback _container" }
const _hoisted_2 = { class: "feedback__something-is-missing" }
const _hoisted_3 = { class: "feedback__wrap-text-and-button" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "feedback__text-missing" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Чего-то не хватает?"),
  /*#__PURE__*/_createElementVNode("p", null, "Предложите идею для привилегии, и мы постараемся её добавить")
], -1)
const _hoisted_5 = { class: "feedback__submit-idea" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"feedback__wrap-submit-idea\"><div class=\"feedback__arcs-footer-icons\"><svg width=\"139\" height=\"92\" viewBox=\"0 0 139 92\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"69.5\" cy=\"22.5\" r=\"62\" stroke=\"#F3F5F7\" stroke-width=\"15\"></circle></svg></div><div class=\"feedback__icons-submit-idea\"><div class=\"feedback__icon-rectangle\"><img src=\"" + _imports_0 + "\" alt=\"\"><div class=\"feedback__icon-speaker\"></div><svg width=\"199\" height=\"76\" viewBox=\"0 0 199 76\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"99.5\" cy=\"99.5\" r=\"92\" stroke=\"#F3F5F7\" stroke-width=\"15\"></circle></svg></div></div></div>", 1)

import FeedbackCreate from './FeedBackCreate.vue'
import Popup from '../../components/Popup/Popup.vue'
import { ref } from 'vue'

// const emit = defineEmits(['feedbackPopupClick'])

export default /*#__PURE__*/_defineComponent({
  __name: 'FeedBack',
  setup(__props) {

const isOpen = ref(false)
const showContent = ref(false)
const openPopup = () => {
  isOpen.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      name: "popup",
      onAfterEnter: _cache[3] || (_cache[3] = ($event: any) => (showContent.value = true))
    }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createBlock(Popup, {
              key: 0,
              open: isOpen.value,
              cards: false,
              feedback: true,
              showContent: showContent.value,
              onPopupClose: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = false)),
              onCloseContent: _cache[2] || (_cache[2] = ($event: any) => (showContent.value = false))
            }, {
              default: _withCtx(() => [
                _createVNode(FeedbackCreate, {
                  onCloseContent: _cache[0] || (_cache[0] = ($event: any) => (showContent.value = false))
                })
              ]),
              _: 1
            }, 8, ["open", "showContent"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (openPopup())),
              style: {"cursor":"pointer"}
            }, " Подать идею ")
          ])
        ]),
        _hoisted_6
      ])
    ])
  ], 64))
}
}

})